const screen = {
    /** @type {Object.<string,jQuery>} */
    elements: {
        $body: $(document.body)
    },

    /** @type {Object.<string,string>} */
    modifiers: {
        noScroll: 'no-scroll'
    },

    lockScroll() {
        this.elements.$body.addClass(this.modifiers.noScroll);
    },

    unlockScroll() {
        this.elements.$body.removeClass(this.modifiers.noScroll);
    },
};

module.exports = screen;
